
import React, { useContext, useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    ToggleButtonGroup,
    ToggleButton,
    Container,
    useTheme,
} from '@mui/material';
import { AppThemeContext } from '../../context/AppThemeContext';

const ColorPaletteDialog = ({ open, onClose, onSelectColors }) => {
    const { setPrimaryColor, PrimaryColor } = useContext(AppThemeContext);
    const [alignment, setAlignment] = useState(PrimaryColor || '#356E35'); // Fallback just in case

    useEffect(() => {
        setAlignment(PrimaryColor);
    }, [PrimaryColor, open]);


    const handleChange = (event, newAlignment) => {
        if (newAlignment) {
            localStorage.setItem('UserTheme', newAlignment);
            setPrimaryColor(newAlignment);
            setAlignment(newAlignment);
        }
    };

    const handleDone = () => {
        onClose();
    };

    const colorGroup = {
        Color1: '#356E35',
       
        
    };

    return (
        <Dialog open={open} component={Container} maxWidth='md' onClose={onClose}>
            <DialogTitle>Choose Color Palette</DialogTitle>
            <DialogContent sx={{}}>
                <FormControl fullWidth>
                    <ToggleButtonGroup
                        color="primary"
                        value={alignment}
                        exclusive
                        onChange={handleChange}
                        aria-label="Platform"
                    >
                        {Object.entries(colorGroup).map(([key, value]) => (
                            <ToggleButton sx={{ bgcolor: `${value}` }} value={value} key={key}>
                                {key}
                            </ToggleButton>
                        ))}
                    </ToggleButtonGroup>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDone} >
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ColorPaletteDialog;

//Day by Day color changing

// import React, { useContext, useEffect, useState } from 'react';
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     Button,
//     FormControl,
//     ToggleButtonGroup,
//     ToggleButton,
//     Container,
// } from '@mui/material';
// import { AppThemeContext } from '../../context/AppThemeContext';

// const ColorPaletteDialog = ({ open, onClose }) => {
// const { setPrimaryColor, PrimaryColor } = useContext(AppThemeContext);

//     const colorGroup = {
//         Color1: "#25476A",
//         Color2: "#574476",
//         Color3: '#356E35',
//         Color4: "#2C3E50",
//         Color5: '#DC143C',
//         Color6: '#B8860B',
//         Color7: '#556B2F',
//         Color8: '#2F4F4F',
//         Color9: "#000000",
//         Color10: "#0f4539",
//         Color11: "#03A9F4",
//         Color12: "#0D6EFD",
//         Color13: '#FFA500',
//         Color14: "#F29F67",
//         Color15: '#f44336',
//         Color16: '#D2691E',
//         Color17: '#FF8C00',
//     };

//     const [alignment, setAlignment] = useState(PrimaryColor || '#2C3E50');
//     const colorKeys = Object.keys(colorGroup);
//     const rotatingKeys = colorKeys.slice(0, 10); // First 10 colors

//     // Automatically rotate every day based on date
//     useEffect(() => {
//         const userSelected = localStorage.getItem('UserTheme_Manual');
//         if (!userSelected) {
//             const today = new Date();
//             const dayIndex = today.getDate() % 10;
//             const rotatingColor = colorGroup[rotatingKeys[dayIndex]];
//             setAlignment(rotatingColor);
//             setPrimaryColor(rotatingColor);
//         }
//     }, [open]);

//     useEffect(() => {
//         setAlignment(PrimaryColor);
//     }, [PrimaryColor, open]);

//     const handleChange = (event, newAlignment) => {
//         if (newAlignment) {
//             localStorage.setItem('UserTheme', newAlignment);
//             localStorage.setItem('UserTheme_Manual', 'true');
//             setPrimaryColor(newAlignment);
//             setAlignment(newAlignment);
//         }
//     };

//     const handleDone = () => {
//         onClose();
//     };

//     return (
//         <Dialog open={open} component={Container} maxWidth="md" onClose={onClose}>
//             <DialogTitle>Choose Color Palette</DialogTitle>
//             <DialogContent>
//                 <FormControl fullWidth>
//                     <ToggleButtonGroup
//                         color="primary"
//                         value={alignment}
//                         exclusive
//                         onChange={handleChange}
//                         aria-label="color theme"
//                     >
//                         {Object.entries(colorGroup).map(([key, value]) =>(
//                             <ToggleButton
//                                 key={key}
//                                 value={value}
//                                 sx={{
//                                     bgcolor: value,
//                                     color: "#fff",
//                                     '&.Mui-selected': {
//                                         border: '2px solid white',
//                                         fontWeight: 'bold',
//                                     }
//                                 }}
//                             >
//                                 {key}
//                             </ToggleButton>
//                         ))}
//                     </ToggleButtonGroup>
//                 </FormControl>
//             </DialogContent>
//             <DialogActions>
//                 <Button onClick={handleDone}>Done</Button>
//             </DialogActions>
//         </Dialog>
//     );
// };

// export default ColorPaletteDialog;
